var render, staticRenderFns
import script from "./baseTableOverview.vue?vue&type=script&lang=js"
export * from "./baseTableOverview.vue?vue&type=script&lang=js"
import style0 from "./baseTableOverview.vue?vue&type=style&index=0&id=4fec8874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec8874",
  null
  
)

export default component.exports